// Firebase Authentication Error Handler
// Maps Firebase error codes to user-friendly messages in Greek

export const getFirebaseErrorMessage = (error) => {
  if (!error || !error.code) {
    return "Παρουσιάστηκε ένα άγνωστο σφάλμα. Παρακαλώ δοκιμάστε ξανά.";
  }

  const errorMessages = {
    // Authentication errors
    'auth/invalid-email': 'Η διεύθυνση email δεν είναι έγκυρη.',
    'auth/user-disabled': 'Ο λογαριασμός σας έχει απενεργοποιηθεί. Επικοινωνήστε με τον διαχειριστή.',
    'auth/user-not-found': 'Δεν βρέθηκε χρήστης με αυτό το email.',
    'auth/wrong-password': 'Ο κωδικός πρόσβασης είναι λανθασμένος.',
    'auth/email-already-in-use': 'Αυτό το email χρησιμοποιείται ήδη από άλλο λογαριασμό.',
    'auth/weak-password': 'Ο κωδικός πρόσβασης είναι πολύ αδύναμος.',
    'auth/operation-not-allowed': 'Αυτή η λειτουργία δεν επιτρέπεται.',
    'auth/too-many-requests': 'Πάρα πολλές προσπάθειες. Παρακαλώ περιμένετε πριν δοκιμάσετε ξανά.',
    'auth/network-request-failed': 'Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας στο internet.',
    'auth/requires-recent-login': 'Αυτή η λειτουργία απαιτεί πρόσφατη σύνδεση. Παρακαλώ συνδεθείτε ξανά.',
    'auth/invalid-credential': 'Τα στοιχεία σύνδεσης δεν είναι έγκυρα.',
    'auth/account-exists-with-different-credential': 'Υπάρχει ήδη λογαριασμός με διαφορετικά στοιχεία.',
    
    // Verification errors
    'auth/invalid-verification-code': 'Ο κωδικός επαλήθευσης δεν είναι έγκυρος.',
    'auth/invalid-verification-id': 'Το ID επαλήθευσης δεν είναι έγκυρο.',
    'auth/missing-verification-code': 'Λείπει ο κωδικός επαλήθευσης.',
    'auth/missing-verification-id': 'Λείπει το ID επαλήθευσης.',
    'auth/code-expired': 'Ο κωδικός επαλήθευσης έχει λήξει.',
    
    // Phone number errors
    'auth/invalid-phone-number': 'Ο αριθμός τηλεφώνου δεν είναι έγκυρος.',
    'auth/missing-phone-number': 'Λείπει ο αριθμός τηλεφώνου.',
    
    // App and credential errors
    'auth/quota-exceeded': 'Υπερβήκατε το όριο αιτημάτων. Παρακαλώ δοκιμάστε αργότερα.',
    'auth/captcha-check-failed': 'Η επαλήθευση CAPTCHA απέτυχε.',
    'auth/invalid-app-credential': 'Τα διαπιστευτήρια της εφαρμογής δεν είναι έγκυρα.',
    'auth/missing-app-credential': 'Λείπουν τα διαπιστευτήρια της εφαρμογής.',
    'auth/invalid-user-token': 'Το token χρήστη δεν είναι έγκυρο.',
    'auth/user-token-expired': 'Το token χρήστη έχει λήξει.',
    'auth/null-user': 'Ο χρήστης είναι null.',
    'auth/app-deleted': 'Η εφαρμογή έχει διαγραφεί.',
    'auth/keychain-error': 'Σφάλμα keychain.',
    'auth/internal-error': 'Εσωτερικό σφάλμα. Παρακαλώ δοκιμάστε ξανά.',
    'auth/invalid-api-key': 'Το API key δεν είναι έγκυρο.',
    'auth/app-not-authorized': 'Η εφαρμογή δεν είναι εξουσιοδοτημένη.',
    
    // Action code errors
    'auth/expired-action-code': 'Ο κωδικός ενέργειας έχει λήξει.',
    'auth/invalid-action-code': 'Ο κωδικός ενέργειας δεν είναι έγκυρος.',
    'auth/missing-action-code': 'Λείπει ο κωδικός ενέργειας.',
    'auth/credential-already-in-use': 'Τα διαπιστευτήρια χρησιμοποιούνται ήδη.',
    
    // Network and timeout errors
    'auth/timeout': 'Η λειτουργία έληξε. Παρακαλώ δοκιμάστε ξανά.',
    'auth/upstream-dependency': 'Σφάλμα εξαρτημένης υπηρεσίας.',
    
    // Missing field errors
    'auth/missing-email': 'Λείπει το email.',
    'auth/missing-password': 'Λείπει ο κωδικός πρόσβασης.',
    
    // Tenant errors
    'auth/invalid-tenant-id': 'Το tenant ID δεν είναι έγκυρο.',
    'auth/tenant-id-mismatch': 'Το tenant ID δεν ταιριάζει.',
    'auth/unsupported-tenant-operation': 'Η λειτουργία tenant δεν υποστηρίζεται.',
    'auth/operation-not-supported-in-this-environment': 'Αυτή η λειτουργία δεν υποστηρίζεται σε αυτό το περιβάλλον.',
    
    // Domain and URI errors
    'auth/unauthorized-domain': 'Μη εξουσιοδοτημένος τομέας.',
    'auth/unauthorized-continue-uri': 'Μη εξουσιοδοτημένη continue URI.',
    'auth/invalid-dynamic-link-domain': 'Ο δυναμικός σύνδεσμος τομέας δεν είναι έγκυρος.',
    
    // General errors
    'auth/argument-error': 'Σφάλμα ορίσματος.',
    'auth/invalid-persistence-type': 'Ο τύπος persistence δεν είναι έγκυρος.',
    'auth/unsupported-persistence-type': 'Ο τύπος persistence δεν υποστηρίζεται.',
    
    // Popup errors
    'auth/popup-blocked': 'Το popup αποκλείστηκε από τον browser.',
    'auth/popup-closed-by-user': 'Το popup έκλεισε από τον χρήστη.',
    'auth/cancelled-popup-request': 'Η αίτηση popup ακυρώθηκε.',
    'auth/popup-window-blocked': 'Το παράθυρο popup αποκλείστηκε.',
  };

  return errorMessages[error.code] || error.message || "Παρουσιάστηκε ένα άγνωστο σφάλμα. Παρακαλώ δοκιμάστε ξανά.";
};

// Helper function to determine if error is retryable
export const isRetryableError = (error) => {
  if (!error || !error.code) return false;
  
  const retryableErrors = [
    'auth/network-request-failed',
    'auth/timeout',
    'auth/too-many-requests',
    'auth/internal-error',
    'auth/upstream-dependency'
  ];
  
  return retryableErrors.includes(error.code);
};

// Helper function to get error severity
export const getErrorSeverity = (error) => {
  if (!error || !error.code) return 'error';
  
  const warningErrors = [
    'auth/too-many-requests',
    'auth/requires-recent-login'
  ];
  
  const infoErrors = [
    'auth/user-not-found',
    'auth/wrong-password'
  ];
  
  if (warningErrors.includes(error.code)) return 'warning';
  if (infoErrors.includes(error.code)) return 'info';
  
  return 'error';
};
